'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * POST designmanager/v1/modules/global
 *
 * @param  {Object} widget  Object containing widget properties.
 */

export function create(widget) {
  return http.post('designmanager/v1/modules/global', {
    data: widget
  });
}